import { render, staticRenderFns } from "./synchronized.vue?vue&type=template&id=0c040619&scoped=true&"
import script from "./synchronized.vue?vue&type=script&lang=js&"
export * from "./synchronized.vue?vue&type=script&lang=js&"
import style0 from "./synchronized.vue?vue&type=style&index=0&id=0c040619&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c040619",
  null
  
)

export default component.exports